// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ord_Generic from "../Data.Ord.Generic/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_UUID from "../Data.UUID/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_PromotionsEngine_Cart_Types from "../Restaumatic.PromotionsEngine.Cart.Types/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
var ProductPizza = /* #__PURE__ */ (function () {
    function ProductPizza() {

    };
    ProductPizza.value = new ProductPizza();
    return ProductPizza;
})();
var ProductDish = /* #__PURE__ */ (function () {
    function ProductDish() {

    };
    ProductDish.value = new ProductDish();
    return ProductDish;
})();
var ProductDrink = /* #__PURE__ */ (function () {
    function ProductDrink() {

    };
    ProductDrink.value = new ProductDrink();
    return ProductDrink;
})();
var ProductSize = function (x) {
    return x;
};
var ProductItemKey = function (x) {
    return x;
};
var ProductId = function (x) {
    return x;
};
var ProductItem = function (x) {
    return x;
};
var udecodeProductSize = Unscramble.decodeInt1;
var productSize = function (v) {
    return v.productSize;
};
var productId = function (v) {
    return v.productId;
};
var productCategoryId = function (v) {
    return v.productCategoryId;
};
var newtypeProductSize = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeProductItemKey = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeProductItem = {
    Coercible0: function () {
        return undefined;
    }
};
var product = /* #__PURE__ */ (function () {
    var $80 = Data_Newtype.unwrap();
    var $81 = Data_Newtype.unwrap();
    return function ($82) {
        return (function (v) {
            return v.product;
        })($80((function (v) {
            return v.productItemKey;
        })($81($82))));
    };
})();
var productItemKey = /* #__PURE__ */ (function () {
    var $83 = Data_Newtype.unwrap();
    return function ($84) {
        return (function (v) {
            return v.productItemKey;
        })($83($84));
    };
})();
var productName = /* #__PURE__ */ (function () {
    var $85 = Data_Newtype.unwrap();
    return function ($86) {
        return (function (v) {
            return v.productName;
        })($85($86));
    };
})();
var productPrice = /* #__PURE__ */ (function () {
    var $87 = Data_Newtype.unwrap();
    return function ($88) {
        return (function (v) {
            return v.productPrice;
        })($87($88));
    };
})();
var productSeq = /* #__PURE__ */ (function () {
    var $89 = Data_Newtype.unwrap();
    var $90 = Data_Newtype.unwrap();
    return function ($91) {
        return (function (v) {
            return v.productSeq;
        })($89((function (v) {
            return v.productItemKey;
        })($90($91))));
    };
})();
var newtypeProductId = {
    Coercible0: function () {
        return undefined;
    }
};
var productType = function (v) {
    return (Data_Newtype.unwrap()(v.productId)).productType;
};
var mkProductItemKey = function (prod) {
    return function (prodSeq) {
        return {
            product: prod,
            productSeq: prodSeq
        };
    };
};
var mkProductItem = function (template) {
    return function (prod) {
        return function (prodSeq) {
            return {
                productItemKey: mkProductItemKey(prod)(prodSeq),
                productName: template.productName,
                productPrice: template.productPrice,
                productId: template.productId,
                productSize: template.productSize,
                dishGroupId: template.dishGroupId,
                productCategoryId: template.productCategoryId,
                itemId: template.itemId,
                customParameters: template.customParameters,
                isCombo: template.isCombo
            };
        };
    };
};
var mkProductItems = function (template) {
    return function (prod) {
        return function (count) {
            return Data_Functor.mapFlipped(Data_Functor.functorArray)(Data_Array.range(1)(count))(mkProductItem(template)(prod));
        };
    };
};
var mkProductId = function (type_) {
    return function (id) {
        return {
            productType: type_,
            productId: new Data_Maybe.Just(id)
        };
    };
};
var mkGenericProductId = function (type_) {
    return {
        productType: type_,
        productId: Data_Maybe.Nothing.value
    };
};
var itemId = function (v) {
    return v.itemId;
};
var isCombo = function (v) {
    return v.isCombo;
};
var genericProductType = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return ProductPizza.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return ProductDish.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return ProductDrink.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.ProductItem (line 134, column 1 - line 134, column 60): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ProductPizza) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ProductDish) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof ProductDrink) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.ProductItem (line 134, column 1 - line 134, column 60): " + [ x.constructor.name ]);
    }
};
var showProductType = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductType)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ProductPizza";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ProductDish";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ProductDrink";
        }
    }))))
};
var udecodeProductType = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericProductType)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ProductPizza";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ProductDish";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ProductDrink";
        }
    }))))(Unscramble_Enum.defaultEnumOptions)
};
var udecodeProductId = /* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "productId";
    }
})(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeInt1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "productType";
    }
})(udecodeProductType)(Unscramble.decodeRecordNil)));
var genericProductSize = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showProductSize = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductSize)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))({
        reflectSymbol: function () {
            return "ProductSize";
        }
    }))
};
var genericProductItemKey = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showProductItemKey = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericProductItemKey)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "product";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productSeq";
            }
        })(Data_Show.showRecordFieldsNil)(Data_Show.showInt))(dictShow))))({
            reflectSymbol: function () {
                return "ProductItemKey";
            }
        }))
    };
};
var genericProductItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericProductId = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showProductId = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductId)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productType";
        }
    })(Data_Show.showRecordFieldsNil)(showProductType))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showInt)))))({
        reflectSymbol: function () {
            return "ProductId";
        }
    }))
};
var showProductItem = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericProductItem)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "customParameters";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "dishGroupId";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "isCombo";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "itemId";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productCategoryId";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productId";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productItemKey";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productName";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productPrice";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "productSize";
            }
        })(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(showProductSize)))(Data_Money_Rounded.showMoney))(Data_Show.showString))(showProductItemKey(dictShow)))(showProductId))(Data_Maybe.showMaybe(Data_UUID.showUUID)))(Data_Maybe.showMaybe(Restaumatic_PromotionsEngine_Cart_Types.showItemId)))(Data_Show.showBoolean))(Data_Maybe.showMaybe(Data_Show.showInt)))(Data_Map_Internal.showMap(Data_UUID.showUUID)(Data_UUID.showUUID)))))({
            reflectSymbol: function () {
                return "ProductItem";
            }
        }))
    };
};
var functorProductItemKey = {
    map: function (f) {
        return function (m) {
            return {
                product: f(m.product),
                productSeq: m.productSeq
            };
        };
    }
};
var eqProductType = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericProductType)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))))
};
var ordProductType = {
    compare: /* #__PURE__ */ Data_Ord_Generic.genericCompare(genericProductType)(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(/* #__PURE__ */ Data_Ord_Generic.genericOrdSum(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments))(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdNoArguments)))),
    Eq0: function () {
        return eqProductType;
    }
};
var eqProductSize = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericProductSize)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_Eq.eqInt)))
};
var ordProductSize = {
    compare: /* #__PURE__ */ Data_Ord_Generic.genericCompare(genericProductSize)(/* #__PURE__ */ Data_Ord_Generic.genericOrdConstructor(/* #__PURE__ */ Data_Ord_Generic.genericOrdArgument(Data_Ord.ordInt))),
    Eq0: function () {
        return eqProductSize;
    }
};
var eqProductItemKey = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericProductItemKey)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
            reflectSymbol: function () {
                return "productSeq";
            }
        })(Data_Eq.eqInt))()({
            reflectSymbol: function () {
                return "product";
            }
        })(dictEq)))))
    };
};
var ordProductItemKey = function (dictOrd) {
    return {
        compare: Data_Ord_Generic.genericCompare(genericProductItemKey)(Data_Ord_Generic.genericOrdConstructor(Data_Ord_Generic.genericOrdArgument(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()({
            reflectSymbol: function () {
                return "productSeq";
            }
        })(Data_Ord.ordInt))()({
            reflectSymbol: function () {
                return "product";
            }
        })(dictOrd))))),
        Eq0: function () {
            return eqProductItemKey(dictOrd.Eq0());
        }
    };
};
var eqProductId = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqInt))(x.productId)(y.productId) && Data_Eq.eq(eqProductType)(x.productType)(y.productType);
        };
    }
};
var eqProductItem = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericProductItem)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
            reflectSymbol: function () {
                return "productSize";
            }
        })(Data_Maybe.eqMaybe(eqProductSize)))()({
            reflectSymbol: function () {
                return "productPrice";
            }
        })(Data_Money_Rounded.eqMoney))()({
            reflectSymbol: function () {
                return "productName";
            }
        })(Data_Eq.eqString))()({
            reflectSymbol: function () {
                return "productItemKey";
            }
        })(eqProductItemKey(dictEq)))()({
            reflectSymbol: function () {
                return "productId";
            }
        })(eqProductId))()({
            reflectSymbol: function () {
                return "productCategoryId";
            }
        })(Data_Maybe.eqMaybe(Data_UUID.eqUUID)))()({
            reflectSymbol: function () {
                return "itemId";
            }
        })(Data_Maybe.eqMaybe(Restaumatic_PromotionsEngine_Cart_Types.eqItemId)))()({
            reflectSymbol: function () {
                return "isCombo";
            }
        })(Data_Eq.eqBoolean))()({
            reflectSymbol: function () {
                return "dishGroupId";
            }
        })(Data_Maybe.eqMaybe(Data_Eq.eqInt)))()({
            reflectSymbol: function () {
                return "customParameters";
            }
        })(Data_Map_Internal.eqMap(Data_UUID.eqUUID)(Data_UUID.eqUUID))))))
    };
};
var ordProductId = {
    compare: function (x) {
        return function (y) {
            var v = Data_Ord.compare(Data_Maybe.ordMaybe(Data_Ord.ordInt))(x.productId)(y.productId);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(ordProductType)(x.productType)(y.productType);
        };
    },
    Eq0: function () {
        return eqProductId;
    }
};
var encodeProductType = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericProductType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ProductPizza";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ProductDish";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ProductDrink";
        }
    }))))
};
var encodeProductSize = Foreign_Generic_Class.intEncode;
var encodeProductItemKey = function (dictEncode) {
    return function (dictEncodeWithOptions) {
        return {
            encode: Foreign_Encoding.defaultEncode(genericProductItemKey)(Foreign_Generic_Class.genericEncodeConstructor({
                reflectSymbol: function () {
                    return "ProductItemKey";
                }
            })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                reflectSymbol: function () {
                    return "productSeq";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
                reflectSymbol: function () {
                    return "product";
                }
            })(dictEncodeWithOptions)))))
        };
    };
};
var encodeProductId = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericProductId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "productType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeProductType)))({
        reflectSymbol: function () {
            return "productId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.intEncode)))))))
};
var dishGroupId = function (v) {
    return v.dishGroupId;
};
var decodeProductType = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericProductType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ProductPizza";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ProductDish";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ProductDrink";
        }
    }))))
};
var decodeProductSize = Foreign_Generic_Class.intDecode;
var decodeProductItemKey = function (dictDecode) {
    return function (dictDecodeWithOptions) {
        return {
            decode: Foreign_Encoding.defaultDecode(genericProductItemKey)(Foreign_Generic_Class.genericDecodeConstructor({
                reflectSymbol: function () {
                    return "ProductItemKey";
                }
            })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                reflectSymbol: function () {
                    return "productSeq";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
                reflectSymbol: function () {
                    return "product";
                }
            })(dictDecodeWithOptions)())))(Foreign_Generic_Class.genericCountArgsArgument))
        };
    };
};
var decodeProductId = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericProductId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "productType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeProductType))())({
        reflectSymbol: function () {
            return "productId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.intDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var customParameters = function (v) {
    return v.customParameters;
};
var ordProductItem = function (dictOrd) {
    return {
        compare: function (a) {
            return function (b) {
                return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidOrdering)([ Data_Ordering.invert(Data_Ord.compare(Data_Money_Rounded.ordMoney)(productPrice(a))(productPrice(b))), Data_Ord.compare(ordProductType)(productType(a))(productType(b)), Data_Ord.compare(Data_Ord.ordString)(productName(a))(productName(b)), Data_Ord.compare(Data_Maybe.ordMaybe(ordProductSize))(productSize(a))(productSize(b)), Data_Ord.compare(Data_Maybe.ordMaybe(Data_UUID.ordUUID))(productCategoryId(a))(productCategoryId(b)), Data_Ord.compare(Data_Maybe.ordMaybe(Restaumatic_PromotionsEngine_Cart_Types.ordItemId))(itemId(a))(itemId(b)), Data_Ord.compare(Data_Map_Internal.ordMap(Data_UUID.ordUUID)(Data_UUID.ordUUID))(customParameters(a))(customParameters(b)), Data_Ord.compare(Data_Ord.ordBoolean)(isCombo(a))(isCombo(b)), Data_Ord.compare(ordProductItemKey(dictOrd))(productItemKey(a))(productItemKey(b)) ]);
            };
        },
        Eq0: function () {
            return eqProductItem(dictOrd.Eq0());
        }
    };
};
var customParameterValues = function (v) {
    return function (customParameterId) {
        return Data_Map_Internal.lookup(Data_UUID.ordUUID)(customParameterId)(v.customParameters);
    };
};
export {
    ProductItem,
    ProductItemKey,
    ProductId,
    mkProductId,
    mkGenericProductId,
    ProductSize,
    ProductPizza,
    ProductDish,
    ProductDrink,
    mkProductItemKey,
    mkProductItem,
    mkProductItems,
    productItemKey,
    product,
    productSeq,
    productPrice,
    productName,
    productId,
    productSize,
    productType,
    dishGroupId,
    productCategoryId,
    itemId,
    isCombo,
    customParameters,
    customParameterValues,
    newtypeProductItem,
    genericProductItem,
    showProductItem,
    eqProductItem,
    ordProductItem,
    functorProductItemKey,
    newtypeProductItemKey,
    genericProductItemKey,
    encodeProductItemKey,
    decodeProductItemKey,
    showProductItemKey,
    eqProductItemKey,
    ordProductItemKey,
    newtypeProductId,
    genericProductId,
    eqProductId,
    ordProductId,
    showProductId,
    encodeProductId,
    decodeProductId,
    udecodeProductId,
    genericProductSize,
    newtypeProductSize,
    encodeProductSize,
    decodeProductSize,
    udecodeProductSize,
    showProductSize,
    eqProductSize,
    ordProductSize,
    genericProductType,
    showProductType,
    eqProductType,
    ordProductType,
    encodeProductType,
    decodeProductType,
    udecodeProductType
};
//# sourceMappingURL=index.js.map
